import { createFileRoute } from '@tanstack/react-router'
import { VaultPage } from '@/features/vault/ui/vault-page'
import { PageLayout } from '@/components/page-layout'

export const Route = createFileRoute('/_authenticated/vault')({
	component: VaultRoute,
})

function VaultRoute() {
	return (
		<PageLayout className='pb-16'>
			<VaultPage />
		</PageLayout>
	)
}
